<template>
  <div class="px-3 py-1 pb-sm-0 pb-3 h-100 d-flex align-items-center">
    <ContentCard
      theme="challenge"
      :status="!challenge ? 'disabled' : !challenge.finished_at && !challengeValidDatePast ? 'not-completed' : 'completed' "
      class="w-100"
    >
      <ChallengeInnerCard
        :challenge="challenge"
        :cycle="cycle"
        :show-result="cycle.show_result"
      />
      <RetryInfo 
        v-if="!challenge.is_running"
        :challenge="challenge"
        :cycle="cycle"
      />
      <button
        v-if="showButton"
        class="bg-transparent border-0 px-0"
        @click="accessChallenge({id: challenge.id, cycle_config_id: cycle.id})"
      >
        <span class="align-middle">Acessar</span>
        <i class="fa fa-arrow-right align-middle" />
      </button>
    </ContentCard>
  </div>
</template>
<script>

import ChallengeInnerCard from "../ChallengeInnerCard";
import RetryInfo from "../RetryInfo";
import ContentCard from "@/common/components/ContentCard";
import { mapActions } from 'vuex';

export default {
  components: {
    ChallengeInnerCard,
    ContentCard,
    RetryInfo,
  },
  props: {
    cycle: {
      type: Object,
      required: true
    },
  },
  computed: {
    challenge(){
      return this.cycle.challenge
    },
    challengeValidDatePast(){
      if (!this.challenge.validUntil) return false;
        return this.$moment(this.challenge.validUntil).isAfter(this.$moment());
    },
    status(){
      if(this.cycle.challenge_type == "online") {
        return this.challenge.finished_at && this.challenge.count_unfinished_retries == 0 ? 'completed' : 'not-completed'
      }else{

        const completed = this.challenge.finished_at && this.challenge.count_unfinished_retries == 0 ;

        if(!this.challenge.show_result || !completed){
          return 'disabled'
        }else{
          return 'complete'
        }
      }
    },
    showButton(){
      
      if(this.cycle.challenge_type == "print") {
        return this.challenge.finished_at && this.cycle.show_result
      }else {
        if(this.challenge.is_running){
          return true
        }else{
          if(this.challenge.count_unfinished_retries > 0 && this.challenge.retry_is_expired && this.challenge.finished_before_reopened)
            return true
          if(this.challenge.count_unfinished_retries > 0 && this.challenge.retry_is_expired && !this.challenge.finished_before_reopened)
            return false
          if(!this.challenge.finished_at && this.challenge.count_unfinished_retries > 0)
            return true
          if(this.challenge.finished_at && this.cycle.show_result)
            return true
          if(this.challenge.finished_at && !this.cycle.show_result)
            return false
          return false
        }
      }  
    }
  },
  methods:{
    ...mapActions(['accessChallenge']),
  }
}
</script>
